import { breakpoint, zIndex } from "shared/styles/constants";
import styled from "styled-components/macro";

export const StyledGalleryModal = styled.div`
  position: relative;

  display: flex;
  align-items: stretch;
  justify-content: center;

  height: 100%;

  .swiper-container {
    width: 100% !important;
  }
`;

export const StyledGalleryModalNavigation = styled.div`
  pointer-events: none;

  position: absolute;
  top: 50%;
  left: 0;
  z-index: ${zIndex.above};

  width: 100%;

  transform: translateY(-50%);

  display: flex;
  justify-content: space-between;

  > *:first-child {
    pointer-events: all;

    transform: translateX(-50%);

    ${breakpoint("m", "down")} {
      transform: scale(0.85);
    }
  }

  > *:last-child {
    pointer-events: all;

    transform: translateX(50%);

    ${breakpoint("m", "down")} {
      transform: scale(0.85);
    }
  }
`;
